import { isQuestionType } from "@app/screens/ExternalQuestionnaires/externalQuestionnaire/services";
import { DropdownFieldWrapper } from "@app/shared/components/DropdownFieldWrapper/DropdownFieldWrapper";
import { Icon } from "@design-system/Icon";
import { Dropdown } from "@design-system/Inputs/UniversalDropdown";
import { Text } from "@design-system/Typography/Text";
import { QuestionType } from "@generated/client/graphql";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "../../i18n";
import { questionTypeToIconName } from "../QuestionsTable/columns/answerCol";

export const QuestionTypeSelect: FC<{
    value?: QuestionType;
    onChange: (value?: QuestionType) => void;
}> = ({ onChange, ...props }) => {
    const { t } = useTranslation(RESOURCE_NAME);
    const value = props.value ? [props.value] : [];
    const handleChange = ([value]: string[]) => {
        if (!value) onChange();

        if (!isQuestionType(value)) throw new Error("Invalid question type");

        onChange(value);
    };

    return (
        <Dropdown
            modal
            onValueChange={handleChange}
            selectType="single"
            value={value}
        >
            <Dropdown.Trigger>
                <DropdownFieldWrapper
                    className="min-w-[260px]"
                    placeholder={t(
                        keys.create_questions_modal_question_type_dd_label,
                    )}
                    placeholderUp={!!props.value}
                    required
                    leadingElement={
                        props.value && (
                            <Icon
                                name={questionTypeToIconName[props.value]}
                                className="text-secondary"
                            />
                        )
                    }
                    trailingElement={
                        <Icon name="chevronDown" className="text-primary" />
                    }
                >
                    <Text>
                        {" "}
                        {props.value
                            ? t(getQuestionTypeLabel(props.value))
                            : ""}
                    </Text>
                </DropdownFieldWrapper>
            </Dropdown.Trigger>
            <Dropdown.Content align="start" hasPortal>
                {Object.values(QuestionType).map((questionType) => (
                    <Dropdown.SelectableItem
                        key={questionType}
                        value={questionType}
                    >
                        <Dropdown.SelectedIndicator />
                        <Dropdown.ItemText>
                            {t(getQuestionTypeLabel(questionType))}
                        </Dropdown.ItemText>
                    </Dropdown.SelectableItem>
                ))}
            </Dropdown.Content>
        </Dropdown>
    );
};

export function getQuestionTypeLabel(questionType: QuestionType) {
    const suffix = questionType.toLowerCase() as Lowercase<QuestionType>;
    return keys[`create_questions_modal_question_type_dd_item_label_${suffix}`];
}
